import { createSlice } from "@reduxjs/toolkit";

const initial = {
  value: {},
};

export const whatsappBusiness = createSlice({
  name: "whatsapp-business",
  initialState: initial,
  reducers: {
    setWhatsappCredentials: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setWhatsappCredentials } = whatsappBusiness.actions;
export default whatsappBusiness.reducer;
